export default __webpack_public_path__ + "static/media/resume-recording.80a3bf51.svg";